import { render, staticRenderFns } from "./ProposalSpecs.vue?vue&type=template&id=06b17b92&scoped=true&"
import script from "./ProposalSpecs.vue?vue&type=script&lang=js&"
export * from "./ProposalSpecs.vue?vue&type=script&lang=js&"
import style0 from "./ProposalSpecs.vue?vue&type=style&index=0&id=06b17b92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b17b92",
  null
  
)

export default component.exports